/* eslint-disable react/prop-types */
import React from 'react';
import { RangePicker } from 'components/Antd/DatePicker';
import FilterDropdownChoosing from './Choosing';
import classes from './FilterDropdown.module.scss';

const FilterDropdownDate = ({ items, checks, setChecks, dateVal, setDateVal }) => {
  const tItems = items || {};
  const itemKeys = Object.keys(items);
  return (
    <div className={classes.filterDropdownChoosing}>
      {itemKeys.map((tKey, i) => {
        return (
          <FilterDropdownChoosing key={i} items={tItems[tKey] || []} checks={checks[tKey] || []} setChecks={val => {
            setChecks({
              ...checks,
              [tKey]: val,
            })
          }} />
        );
      })}
      
      <RangePicker placeholder={['From', 'To']} size="large" value={dateVal} onChange={val => {
        setDateVal(val);
      }} />
    </div>
  );
}

export default FilterDropdownDate;